import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // i18n 불러오기
import { noticeList } from '../../data/NoticeData';
import { IoIosArrowBack } from "react-icons/io";
import { NavLink } from 'react-router-dom';

const NoticeDetails = () => {
  const { t } = useTranslation(); // useTranslation 사용
  const { id } = useParams<{ id: string }>();
  const notice = noticeList.find((n) => n.id === parseInt(id || '0'));
  const navigate = useNavigate();

  if (!notice) {
    return <p>{t('notice.no_notices')}</p>; // 공지사항을 찾을 수 없습니다
  }

  return (
    <section className="max-w-[2560px] w-full mx-auto mt-[88px] mb-[100px] mobile:px-4">
      <div className="mt-[130px] max-w-[1440px] w-full mx-auto">
        <div className='py-[30px] mobile:py-4'>
          <h1 className="text-4xl text-[#141414] Pretendard-Bold mobile:text-lg mb-4">{notice.title}</h1>
          <div className='flex items-center'>
            <div className="mr-7 mobile:mr-3 w-[100px]">
              <NavLink to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/logo/logo.png`}
                  alt="Creator Store"
                  className="w-full h-auto object-cover"
                />
              </NavLink>
            </div>
            <p className="text-[#afafaf] mobile:text-[13px] Pretendard-Regular">{notice.date}</p>
          </div>
        </div>

        <div className="flex py-[80px] mobile:py-[30px] items-start border-t-2 border-b-2">
          <div className="flex-1">
            <div className="flex justify-center">
              <img src={`${process.env.PUBLIC_URL}/announce.png`} alt="Vendor Showcase"
                className="w-full max-w-7xl mb-[25px]"
                style={{
                  imageRendering: 'pixelated', // 이미지를 선명하게 렌더링
                }} />
            </div>
            <p className="whitespace-pre-line leading-7 Pretendard-Regular text-lg  mobile:text-[11px] mobile:leading-5 text-[#272d37] flex mt-[50px] mobile:mt-[28px]">
              <img
                src={`${process.env.PUBLIC_URL}/assets/mc1.png`}
                alt="공지 아이콘"
                className="w-16 h-16 mr-4"
                style={{
                  transform: 'scaleX(-1)', // 좌우 반전
                  imageRendering: 'pixelated', // 이미지를 선명하게 렌더링
                }}
              />
              <span dangerouslySetInnerHTML={{ __html: notice.content }} />
            </p>
          </div>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="flex items-center mt-[100px] mobile:mt-[60px] space-x-2 border py-2 px-3 Pretendard-Regular text-lg mobile:text-xs text-[#757575] bg-white transition duration-300 ease-in-out hover:bg-slate-50"
        >
          <IoIosArrowBack className='mr-1' />
          {t('notice.return_to_list')} {/* 목록으로 돌아가기 */}
        </button>
      </div>
    </section>
  );
};

export default NoticeDetails;
